import { UPDATE_CONTRACT_DETAIL } from "./proposalTab.reducer";

export const upadateContractDetail = (data) => (dispatch) => {
  return dispatch({ type: UPDATE_CONTRACT_DETAIL, payload: data });
};
